import axios, { AxiosRequestConfig } from 'axios';
import { getRequestUrlHelper } from '~/src/helpers/get-request-url.helper';
import { captureException } from '@sentry/nextjs';
import { API_HOST_ENV } from '~/src/params';
import {
    apiKeyCreateLead,
    apiKeyCreateLeadNotAuth,
    apiKeyCreateLeadReferral,
    apiKeyListLead,
    apiKeyMarketplace,
    defaultUrlCreateLead,
    defaultUrlCreateLeadNotAuth,
    defaultUrlCreateLeadReferral,
    defaultUrlListLead,
    defaultUrlMarketplace,
    defaultUrlReportByListLead,
    apiKeyTechAbility,
    defaultUrlTechAbility,
} from '~/src/repositories/lead/api-urls';
import type {
    ActivatePromotionalCodeParamsInterface,
    CreateLeadInterface,
    CreateLeadNotAuthInterface,
    CreateLeadReferralInterface,
    LeadListSearchParamsInterface,
    LeadPageDataInterface,
} from '~/src/repositories/lead/types/lead.types';

export const createLead = async (data: CreateLeadInterface, isSSR?: boolean) => {
    const url = getRequestUrlHelper({
        isSSR,
        apiKey: apiKeyCreateLead,
        defaultUrl: defaultUrlCreateLead,
    });

    return await axios.post<CreateLeadInterface>(url, data);
};

export const createLeadReferral = async (data: CreateLeadReferralInterface, isSSR?: boolean) => {
    const url = getRequestUrlHelper({
        isSSR,
        apiKey: apiKeyCreateLeadReferral,
        defaultUrl: defaultUrlCreateLeadReferral,
    });

    return await axios.post<CreateLeadReferralInterface>(url, data);
};

export const createLeadNotAuth = async (data: CreateLeadNotAuthInterface, isSSR?: boolean) => {
    const url = getRequestUrlHelper({
        isSSR,
        apiKey: apiKeyCreateLeadNotAuth,
        defaultUrl: defaultUrlCreateLeadNotAuth,
    });

    return await axios.post<CreateLeadNotAuthInterface>(url, data);
};

export const getListLead = async (searchParams: LeadListSearchParamsInterface, isSSR?: boolean) => {
    const url = getRequestUrlHelper({
        isSSR,
        apiKey: apiKeyListLead,
        defaultUrl: defaultUrlListLead,
    });

    const config = {
        params: searchParams,
    };

    try {
        const { data } = await axios.get<LeadPageDataInterface>(url, config);
        return data;
    } catch (error: unknown) {
        // eslint-disable-next-line no-console
        console.log(error);
        captureException(error);
        return null;
    }
};

export const getReportByLeads = async (dateFrom: string, dateTo: string) => {
    const config: AxiosRequestConfig = {
        responseType: 'blob',
        params: {
            dateFrom,
            dateTo,
        },
    };
    return await axios.get<Blob>(`${API_HOST_ENV}/${defaultUrlReportByListLead}`, config);
};

export const getActivatePromotionalCodeRequest = async (
    data: ActivatePromotionalCodeParamsInterface,
    isSSR?: boolean,
) => {
    const url = getRequestUrlHelper({
        isSSR,
        apiKey: apiKeyMarketplace,
        defaultUrl: defaultUrlMarketplace,
    });

    return await axios.post<ActivatePromotionalCodeParamsInterface>(url, data);
};

export const getTechAbility = async (
    houseFiasId: string,
    isSSR?: boolean,
): Promise<string> => {
    const url = getRequestUrlHelper({
        isSSR,
        apiKey: apiKeyTechAbility,
        defaultUrl: defaultUrlTechAbility,
    });

    const config = {
        params: {
            houseFiasId,
        },
    };

    const { data } = await axios.get<string>(url, config);

    return data;
};
